import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useDrag } from '@use-gesture/react';
import { useSpringCarousel } from 'react-spring-carousel'
import './TikTok.scss';
import Carousel from './common/Carousel';
import useStore from './context/hooks';


const TikTok = forwardRef(({ selected, onChange, onDrag, hierarchy, renderItem, disableKeyboard, onStartChange }, ref) => {
  const apiRef = React.useRef();
  const threshold = 5; // Minimum distance to trigger swipe
  const { state } = useStore()

  const newItems = []
  const storiesArray = []
  const nodes = []
  let initialActiveItem = 0
  const current = hierarchy.find(v => v.data.id === selected)
  hierarchy.each((node, j) => {
    nodes.push(node)
    if (newItems.find(i => node.data.parent && i.id === node.data.parent + '-children')) return
    if (node.depth > current.depth && !node.ancestors().find(n => n.data.id === current.data.id)) {
      return
    }
    newItems.push({
      id: node.data.id,
      renderItem: renderItem(node.data.id)
    })
    storiesArray.push(node.data.id)
    if (node.children && node.children.length > 1) {
      const arr = []
      const items = node.children.map(c => {
        arr.push(c.data.id)
        return ({
          id: c.data.id,
          renderItem: renderItem(c.data.id)
        })
      })
      storiesArray.push(arr)
      newItems.push({
        id: node.data.id + '-children',
        renderItem: <Carousel
          items={items}
          initialActiveItem={items.findIndex(i => i.id === selected)}
          disableKeyboard={disableKeyboard || !items.find(i => i.id === selected) || state.modal}
          carouselSlideAxis='y'
          onEvent={e => {
            if (e.eventName === 'onSlideStartChange') {
              onStartChange && onStartChange(e.nextItem.id)
            } else if (e.eventName === 'onSlideChange') {
              const thisIndex = items.findIndex(i => i.id === e.currentItem.id)
              console.log('onSlideChange', items, thisIndex)
              onChange && onChange(e.currentItem.id)
            } else if (e.eventName === 'onDrag') {
              onDrag && onDrag(true)
            }
          }}
        />
      })
    }
  })
  if (selected) {
    initialActiveItem = storiesArray.findIndex(i => Array.isArray(i) ? i.includes(selected) : i === selected)
  }
  const [indexH, setIndexH] = useState(initialActiveItem); // Horizontal Index

  const { 
    carouselFragment, 
    useListenToCustomEvent,
    slideToItem
  } = useSpringCarousel({
    initialActiveItem,
    items: newItems,
  })
  useEffect(() => {
    const handleKeyDown = (event) => {
      // console.log('keydown', event.key)
      if (event.key === 'ArrowLeft') {
        apiRef.current.left();
      } else if (event.key === 'ArrowRight') {
        apiRef.current.right();
      }
    };
    if (!disableKeyboard && !state.modal) {
      window.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [hierarchy, disableKeyboard, state.modal]);


  useListenToCustomEvent(e => {
    if (e.eventName === 'onSlideStartChange') {
      const item = e.nextItem
      let storyId = item.id
      if (item.id.includes('-children')) {
        const parentIndex = storiesArray.findIndex(i => i === item.id.split('-')[0])
        storyId = storiesArray[parentIndex + 1][0]
      }
      onStartChange && onStartChange(storyId)

    } else if (e.eventName === 'onSlideChange') {
      const item = e.currentItem
      let storyId = item.id
      if (item.id.includes('-children')) {
        const parentIndex = storiesArray.findIndex(i => i === item.id.split('-')[0])
        storyId = storiesArray[parentIndex + 1][0]
        setIndexH(parentIndex + 1)
      } else {
        setIndexH(storiesArray.findIndex(i => i === storyId))
      }
      onChange && onChange(storyId)
    } else if (e.eventName === 'onDrag') {
      onDrag && onDrag(true)
    }
  })
  apiRef.current = {
    right: (animated) => {
      if (indexH + 1 < newItems.length) {
        setIndexH(indexH + 1)
      }
    },
    left: (animated) => {
      if (indexH - 1 >= 0) {
        setIndexH(indexH - 1)
      }
    },
    up: (animated) => {
    },
    down: (animated) => {
    },
    goto: (x, y, animated) => {
      setIndexH(x)
      slideToItem(x)
    }
  } 
  useEffect(() => {
    slideToItem(indexH)
    apiRef.current.right = () => {
      if (indexH + 1 < newItems.length) {
        setIndexH(indexH + 1)
      }
    }
    apiRef.current.left = () => {
      if (indexH - 1 >= 0) {
        setIndexH(indexH - 1)
      }
    }
  }, [indexH])

  useImperativeHandle(ref, () => apiRef.current);




  return (
    <div className='tiktok w-full relative aspect-square'>
      {carouselFragment}
    </div>
  );
});

export default TikTok;
